/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const createOrganizationBodyOrganizationNameMin = 2;
export const createOrganizationBodyOrganizationNameMax = 100;

export const CreateOrganizationBody = zod
	.object({
		organization: zod.object({
			name: zod
				.string()
				.min(createOrganizationBodyOrganizationNameMin)
				.max(createOrganizationBodyOrganizationNameMax)
				.optional()
				.describe('Organization name')
		})
	})
	.describe('Create or update organization request');

export type CreateOrganizationBody = zod.input<typeof CreateOrganizationBody>;
export type CreateOrganizationBodyOutput = zod.output<typeof CreateOrganizationBody>;
